// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cp .feedbck .user{display:inline-block}.cp .feedbck .user .avatar{border-radius:50%;border-style:solid;border-width:2px;display:inline-block;height:40px;overflow:hidden;vertical-align:middle;width:40px}.cp .feedbck .user .avatar img{height:auto;width:100%}.cp .feedbck ul{list-style:none}.cp .feedbck ul li{border:1px solid;margin:10px 5px;padding:10px}.cp .feedbck .attach{display:block;margin-top:5px;width:200px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
